
export const onAdvancingRequest = (callback: (dto: server.dto.AdvancingRequest) => void) => {
    window.signalRConnections.hub.on("AdvancingRequest", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("AdvancingRequest", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("AdvancingRequest")
    }
}

export const onNewAdvancingMessage = (callback: (dto: server.dto.AdvancingMessage) => void) => {
    window.signalRConnections.hub.on("NewAdvancingMessage", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("NewAdvancingMessage", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("NewAdvancingMessage")
    }
}

export const onAdvancingUpload = (callback: (dto: server.dto.AdvancingUpload) => void) => {
    window.signalRConnections.hub.on("AdvancingUpload", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("AdvancingUpload", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("AdvancingUpload")
    }
}

export const onAdvancingDeletion = (callback: (clientFileId: number) => void) => {
    window.signalRConnections.hub.on("AdvancingDeletion", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("AdvancingDeletion", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("AdvancingDeletion")
    }
}

export const onAdvancingResponse = (callback: (dto: server.dto.AdvancingResponse) => void) => {
    window.signalRConnections.hub.on("AdvancingResponse", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("AdvancingResponse", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("AdvancingResponse")
    }
}

export const onCheatingDetected = (callback: () => void) => {
    window.signalRConnections.hub.on("CheatingDetected", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("CheatingDetected", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("CheatingDetected")
    }
}

export const onAddNotifications = (callback: (dto: server.dto.NotificationForBrowser) => void) => {
    window.signalRConnections.hub.on("AddNotifications", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("AddNotifications", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("AddNotifications")
    }
}

export const onArtistRiderActivity = (callback: (dto: server.dto.ArtistRiderActivity) => void) => {
    window.signalRConnections.hub.on("ArtistRiderActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ArtistRiderActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ArtistRiderActivity")
    }
}

export const onBookkeepingActivity = (callback: (dto: server.dto.BookkeepingActivity) => void) => {
    window.signalRConnections.hub.on("BookkeepingActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("BookkeepingActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("BookkeepingActivity")
    }
}

export const onBankAccountActivity = (callback: (dto: server.dto.BankAccountActivity) => void) => {
    window.signalRConnections.hub.on("BankAccountActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("BankAccountActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("BankAccountActivity")
    }
}

export const onClientActivity = (callback: (dto: server.dto.ClientActivity) => void) => {
    window.signalRConnections.hub.on("ClientActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ClientActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ClientActivity")
    }
}

export const onCompanyActivity = (callback: (dto: server.dto.CompanyActivity) => void) => {
    window.signalRConnections.hub.on("CompanyActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("CompanyActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("CompanyActivity")
    }
}

export const onContactActivity = (callback: (dto: server.dto.ContactActivity) => void) => {
    window.signalRConnections.hub.on("ContactActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ContactActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ContactActivity")
    }
}

export const onCostCenterActivity = (callback: (dto: server.dto.CostCenterActivity) => void) => {
    window.signalRConnections.hub.on("CostCenterActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("CostCenterActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("CostCenterActivity")
    }
}

export const onESignActivity = (callback: (dto: server.dto.ESignActivity) => void) => {
    window.signalRConnections.hub.on("ESignActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ESignActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ESignActivity")
    }
}

export const onExcelTemplateActivity = (callback: (dto: server.dto.ExcelTemplateActivity) => void) => {
    window.signalRConnections.hub.on("ExcelTemplateActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ExcelTemplateActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ExcelTemplateActivity")
    }
}

export const onFlightActivity = (callback: (dto: server.dto.FlightActivity) => void) => {
    window.signalRConnections.hub.on("FlightActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("FlightActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("FlightActivity")
    }
}

export const onExternalCalendarActivity = (callback: (dto: server.dto.ExternalCalendarActivity) => void) => {
    window.signalRConnections.hub.on("ExternalCalendarActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ExternalCalendarActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ExternalCalendarActivity")
    }
}

export const onGroundTransportActivity = (callback: (dto: server.dto.GroundTransportActivity) => void) => {
    window.signalRConnections.hub.on("GroundTransportActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("GroundTransportActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("GroundTransportActivity")
    }
}

export const onGueslistActivity = (callback: (dto: server.dto.GuestlistActivity) => void) => {
    window.signalRConnections.hub.on("GueslistActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("GueslistActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("GueslistActivity")
    }
}

export const onICalendarTemplateActivity = (callback: (dto: server.dto.ICalendarTemplateActivity) => void) => {
    window.signalRConnections.hub.on("ICalendarTemplateActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ICalendarTemplateActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ICalendarTemplateActivity")
    }
}

export const onICalendarFeedActivity = (callback: (dto: server.dto.ICalendarFeedActivity) => void) => {
    window.signalRConnections.hub.on("ICalendarFeedActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ICalendarFeedActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ICalendarFeedActivity")
    }
}

export const onInvoiceActivity = (callback: (dto: server.dto.InvoiceActivity) => void) => {
    window.signalRConnections.hub.on("InvoiceActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("InvoiceActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("InvoiceActivity")
    }
}

export const onProductTemplateActivity = (callback: (dto: server.dto.ProductTemplateActivity) => void) => {
    window.signalRConnections.hub.on("ProductTemplateActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ProductTemplateActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ProductTemplateActivity")
    }
}

export const onProductionActivity = (callback: (dto: server.dto.ProductionActivity) => void) => {
    window.signalRConnections.hub.on("ProductionActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ProductionActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ProductionActivity")
    }
}

export const onShowActivity = (callback: (dto: server.dto.ShowActivity) => void) => {
    window.signalRConnections.hub.on("ShowActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("ShowActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("ShowActivity")
    }
}

export const onTrainActivity = (callback: (dto: server.dto.TrainActivity) => void) => {
    window.signalRConnections.hub.on("TrainActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("TrainActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("TrainActivity")
    }
}

export const onUserActivity = (callback: (dto: server.dto.UserActivity) => void) => {
    window.signalRConnections.hub.on("UserActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("UserActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("UserActivity")
    }
}

export const onUserToClientActivity = (callback: (dto: server.dto.UserToClientActivity) => void) => {
    window.signalRConnections.hub.on("UserToClientActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("UserToClientActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("UserToClientActivity")
    }
}

export const onUserTaskTemplateActivity = (callback: (dto: server.dto.UserTaskTemplateActivity) => void) => {
    window.signalRConnections.hub.on("UserTaskTemplateActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("UserTaskTemplateActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("UserTaskTemplateActivity")
    }
}

export const onWebformActivity = (callback: (dto: server.dto.WebformActivity) => void) => {
    window.signalRConnections.hub.on("WebformActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("WebformActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("WebformActivity")
    }
}

export const onWordTemplateActivity = (callback: (dto: server.dto.WordTemplateActivity) => void) => {
    window.signalRConnections.hub.on("WordTemplateActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("WordTemplateActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("WordTemplateActivity")
    }
}

export const onWordTemplateForListViewActivity = (callback: (dto: server.dto.WordTemplateForListViewActivity) => void) => {
    window.signalRConnections.hub.on("WordTemplateForListViewActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("WordTemplateForListViewActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("WordTemplateForListViewActivity")
    }
}

export const onMessateTemplateActivity = (callback: (dto: server.dto.MessageTemplateActivity) => void) => {
    window.signalRConnections.hub.on("MessateTemplateActivity", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("MessateTemplateActivity", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("MessateTemplateActivity")
    }
}

export const onUpdateExtractorSession = (callback: (dto: server.dto.ExtractorSession) => void) => {
    window.signalRConnections.hub.on("UpdateExtractorSession", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("UpdateExtractorSession", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("UpdateExtractorSession")
    }
}

export const onSetLifeCycleForSessions = (callback: (dto: server.dto.SetExtractorSessionsLifeCycleInstruction) => void) => {
    window.signalRConnections.hub.on("SetLifeCycleForSessions", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("SetLifeCycleForSessions", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("SetLifeCycleForSessions")
    }
}

export const onSetCreditAccount = (callback: (dto: server.dto.CreditAccount) => void) => {
    window.signalRConnections.hub.on("SetCreditAccount", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("SetCreditAccount", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("SetCreditAccount")
    }
}

export const onSetNotificationBadge = (callback: (badge: number) => void) => {
    window.signalRConnections.hub.on("SetNotificationBadge", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("SetNotificationBadge", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("SetNotificationBadge")
    }
}

export const onNotificationsRead = (callback: (notificationIds: number[]) => void) => {
    window.signalRConnections.hub.on("NotificationsRead", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("NotificationsRead", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("NotificationsRead")
    }
}

export const onNotificationsUnread = (callback: (notificationIds: number[]) => void) => {
    window.signalRConnections.hub.on("NotificationsUnread", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("NotificationsUnread", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("NotificationsUnread")
    }
}

export const onNotificationsHidden = (callback: (notificationIds: number[]) => void) => {
    window.signalRConnections.hub.on("NotificationsHidden", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("NotificationsHidden", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("NotificationsHidden")
    }
}

export const onSerializationCheck = (callback: (serializationCheckDto: server.dto.SerializationCheck) => void) => {
    window.signalRConnections.hub.on("SerializationCheck", callback);

    return {
        removeEvent: () => window.signalRConnections.hub.off("SerializationCheck", callback),
        removeAllEvents: () => window.signalRConnections.hub.off("SerializationCheck")
    }
}
